<template>
    <label class="form-input-label mb-2">
        <span v-if="value">{{ value }}</span>
        <span v-else><slot /></span>
        &nbsp;<Asterisk v-if="asterisk" />
    </label>
</template>

<script setup>
import Asterisk from "./Asterisk.vue";

defineProps({
    value: String,
    asterisk: Boolean,
});
</script>
